import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=b7b77ab2&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=ts&"
export * from "./Topbar.vue?vue&type=script&lang=ts&"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=b7b77ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b77ab2",
  null
  
)

export default component.exports